var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"emptycontent"}},[_c('div',{staticClass:"icon-mail"}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.t('mail', 'No messages in this folder')))])])}
var staticRenderFns = []

export { render, staticRenderFns }